import { BranchGetAllUseCase } from '../../../../application';

export default class BranchGetAllService {

    async execute(event) {
        const data = await BranchGetAllUseCase(event);
        return data;
    }
}
